'use client';

import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { detectRegion, saveConsent, getConsent, logConsentAction, type ConsentRegion } from '@/lib/consent';

export default function CookieBanner() {
  const [region, setRegion] = useState<ConsentRegion>('none');
  const [isVisible, setIsVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const detectedRegion = detectRegion();
    setRegion(detectedRegion);
    const existingConsent = getConsent();
    if (!existingConsent && detectedRegion !== 'none') { setIsVisible(true); }
  }, []);

  if (!mounted || !isVisible || region === 'none') return null;

  const handleAcceptAll = () => {
    const choices = { necessary: true as const, analytics: true, marketing: true, preferences: true };
    saveConsent(choices, region);
    logConsentAction('accept_all', region, choices);
    setIsVisible(false);
  };

  const handleRejectAll = () => {
    const choices = { necessary: true as const, analytics: false, marketing: false, preferences: false };
    saveConsent(choices, region);
    logConsentAction('reject_all', region, choices);
    setIsVisible(false);
  };

  if (region === 'gdpr') {
    return (
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-2">Gestione dei Cookie</h3>
                <p className="text-sm text-muted-foreground mb-3">Utilizziamo i cookie per migliorare la tua esperienza. Leggi la nostra <a href="/privacy" className="text-primary hover:underline">Privacy Policy</a> e <a href="/cookie-policy" className="text-primary hover:underline">Cookie Policy</a>.</p>
              </div>
              <button onClick={() => setIsVisible(false)} className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors" aria-label="Chiudi"><X size={20} /></button>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-end">
              <button onClick={handleRejectAll} className="px-4 py-2 border border-border rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors">Rifiuta Tutto</button>
              <button onClick={handleRejectAll} className="px-4 py-2 border border-border rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors">Gestisci Preferenze</button>
              <button onClick={handleAcceptAll} className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors">Accetta Tutto</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (region === 'ccpa') {
    return (
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-4">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground">Utilizziamo i cookie per migliorare la tua esperienza. Puoi esercitare i tuoi diritti visitando <a href="/privacy#do-not-sell" className="text-primary hover:underline">Non Vendere i Miei Dati Personali</a>.</p>
            </div>
            <button onClick={() => { const choices = { necessary: true as const, analytics: true, marketing: false, preferences: true }; saveConsent(choices, region); logConsentAction('dismiss', region, choices); setIsVisible(false); }} className="flex-shrink-0 px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors">Ho Capito</button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
